module.exports = __webpack_public_path__ + "img/petstairs13.67fee145.jpg";